import { useEffect, useState } from "react"
import Facility from "../../../../../../libs/api/services/Facility"
import QBuilderSearch from "../../../builder/components/Generic/QBuilderSearch"

export default function FacilitiesComponent({
    component,
    onUserInput,
    onUserInputComplete,
    defaultValues,
    test
}) {
    const [facilities, setFacilities] = useState()

    // Sanitize defaultValues
    let _defaultValue = defaultValues
    if (typeof defaultValues === 'string' && defaultValues.startsWith('{')) {
        try {
            console.warn("Parsing defaultValues as JSON for backwards compatibility", defaultValues);
            _defaultValue = JSON.parse(defaultValues);
            if (Object.keys(_defaultValue).length > 0 && _defaultValue.hasOwnProperty('facility')) {
                _defaultValue = _defaultValue.facility;
                console.warn("Translated to new format", _defaultValue);
            }
        } catch (e) {
            console.error("Error parsing defaultValues as JSON", e);
        }
    } else if (typeof defaultValues === 'string' && defaultValues.startsWith('"')) {
        try {
            console.warn("Parsing defaultValues as string for backwards compatibility", defaultValues);
            _defaultValue = JSON.parse(defaultValues);
        } catch (e) {
            console.error("Error parsing defaultValues as string", e);
        }
    }

    console.log('test -->', test)
    useEffect(() => {
        Facility.list().then((f) => { setFacilities(f) })
    }, [])
    if (!facilities) return <></>
    return (<>
        <QBuilderSearch
            defaultValue={_defaultValue}
            placeholder={'Facility'}
            details={{
                data: facilities,
                options: {
                    reRefKey: 'facility',
                    template: [{
                        refKey: 'facility',
                        descr: '',
                    }]
                }
            }}
            onsBeforeSearch={() => { }}
            onAfterSearch={() => { }}
            onSelected={(r) => {
                onUserInput(r)
                onUserInputComplete(r)
            }}
        />
    </>
    )
}
